import datos from "src/services/datos";
import Swal from "sweetalert2";
import esArray from "src/general_components/functionEsArray";
const departamentos = new datos("departamento");

export const getDepartamentos = async (auth) => {
  departamentos.addCondition("departamento", "id", 0, ">");
  const response = await departamentos.get();
  return esArray(response.wsResponse.departamento);
};

export const getDepartamentosPaginated = async (limit, offset) => {
  departamentos.addCondition("departamento", "id", 0, ">");
  departamentos.addLimitCondition(limit, offset);
  const response = await departamentos.get();
  /* devuelvo un objeto de respuesta generica  CON ELEMENTO DE "TOTAL_RECORDS" PARA USARSE CON PAGINACION*/

  let result = {};
  if (!response.wsResponse.empty) {
    result = {
      data: esArray(response.wsResponse.departamento),
      total_records: response.wsResponse.total_records,
    };
    return result;
  }
};

export const deleteDepartamentos = async (id) => {
  let status = false;
  await Swal.fire({
    title: "Esta seguro de que desea eliminar este Departamento?",
    text: "Si sigue adelante, no se podran revertir los cambios!",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Si, quiero eliminarlo!",
    cancelButtonText: "No, no estoy seguro!",
  }).then(async (result) => {
    if (result.isConfirmed) {
      const departamentos = new datos("departamento");
      let data = {
        id: id,
      };
      const response = await departamentos.delete(data);

      if (response.status === "true") {
        status = true;
        await Swal.fire(
          "Eliminado!",
          "El Departamento ha sido eliminado exitosamente",
          "success"
        );
      } else {
        await Swal.fire({
          icon: "error",
          title: "Oops...",
          text: response.message,
        });
      }
    }
  });
  return status;
};